export type UploadedFiles = UploadedFile[];

export interface UploadedFile {
  id: FileId;
  name: FileName;
  kind: FileKind;
  size: FileSize;
  type: FileType;
}

export type FileIds = FileId[];

export type FileId = number;

export type FileName = string;

export const enum FileKind {
  File = 'file',
  CV = 'cv'
}

export type FileSize = number;

export type FileTypes = FileType[];

export enum FileType {
  PDF = '.pdf',
  DOC = '.doc',
  DOCX = '.docx'
}

export type FileMimeTypes = FileMimeType[];

export enum FileMimeType {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}
